import { FC } from "react";
import Icon from "components/icon";
import FullLayout from "layouts/full";
import "./index.scss";

interface LoadingProps {
  message?: string;
};

const Loading: FC<LoadingProps> = ({ message = "Loading..." }: LoadingProps) => (
  <FullLayout>
    <div className="app-loading">
      <Icon name="sasr" />
      <div className="message text-muted">{message}</div>
    </div>
  </FullLayout>
);

export default Loading;
